import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Stack
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useCommonApi } from '../../api';
import { PATHS } from '../../paths';
import { DialogAccidentList } from './DialogAccidentList';

interface TipperRemoveDialogProps extends Omit<DialogProps, 'id'> {
  onRemove: () => void;
  title: string;
  isLoading?: boolean;
  id: number;
}
export const RegistryRemoveDialog = ({ onRemove, title, open, onClose, id, isLoading }: TipperRemoveDialogProps) => {
  const navigate = useNavigate();

  const { data: registryAccidents, isLoading: isLoadingRegistryAccidents } = useQuery({
    ...useCommonApi().getAccidentBySources(id),
    enabled: !!id
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        {isLoadingRegistryAccidents ? (
          <Stack direction="row" justifyContent="center" py={3}>
            <CircularProgress color="primary" />
          </Stack>
        ) : (
          <DialogContentText id="alert-dialog-description">
            {!isEmpty(registryAccidents)
              ? 'Tento záznam má na sobě navázané níže vypsané nehody. Opravdu chcete záznam smazat? Tento krok nelze vzít zpět.'
              : 'Opravdu chcete smazat tento záznam? Tento krok nelze vzít zpět.'}
          </DialogContentText>
        )}
        {!isLoadingRegistryAccidents && registryAccidents?.items && !isEmpty(registryAccidents.items) && (
          <DialogAccidentList accidents={registryAccidents?.items} onClick={(id) => navigate(PATHS.ACCIDENTS(id))} />
        )}
      </DialogContent>
      <DialogActions
        sx={{
          py: 4,
          justifyContent: 'center',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          gap: 2
        }}
      >
        <Button onClick={() => onClose?.({}, 'backdropClick')}>Zavřít</Button>
        <Button autoFocus variant="contained" color="error" onClick={onRemove} loading={isLoading}>
          Smazat záznam
        </Button>
      </DialogActions>
    </Dialog>
  );
};
